import { el, mount, unmount } from 'redom';

import application from 'application';

import externalEventCodes from 'event-system/codes/external';

import eventLocationTypes from 'constants/event-location-types';
import eventStatuses from 'constants/event-statuses';

import JoinInstructionsDisplay from './join-instructions';

class EventBodyContainer {

  constructor(event) {

    this.recordingDisplay = null;
    this.joinInstructionsDisplay = null;

    this.event = event;
    this.liveStreamEvent = this.isHelpTapLiveStreamEvent();

    this.el = el('.event-body-container');

    this.initialize();

  }

  onunmount() {

    application.eventSystem.internal.offAllOn(this);

  }

  isHelpTapLiveStreamEvent() {

    return this.event.location.type === eventLocationTypes.HELPTAP_LIVESTREAM;

  }

  canShowRecording() {

    if (this.event.status === eventStatuses.ENDED && this.liveStreamEvent === true) {
      return true;
    }

    return false;

  }

  mountRecordingDisplay() {

    const meeting = this.event.location.meeting;

    if (meeting === null) {
      return false;
    }
    const recording = meeting.recording;

    if (recording.completed === false) {
      this.recordingDisplay = el('label.processing-event-recording-text', 'Please wait. Event recording is being processed.');
    } else {
      this.recordingDisplay = el('ht-video', { source: this.event.location.meeting.recording.url, squaredcorners: true });
    }

    mount(this.el, this.recordingDisplay);

    return true;

  }

  mountJoinInstructionsDisplay() {

    this.joinInstructionsDisplay = new JoinInstructionsDisplay(this.event);

    mount(this.el, this.joinInstructionsDisplay);

  }

  unmountJoinInstructionsDisplay() {

    unmount(this.el, this.joinInstructionsDisplay);

  }

  handleStartupEventEndedEvent(data) {

    this.event = data.event;
    const mounted = this.mountRecordingDisplay();

    if (mounted === false) {
      return;
    }

    this.unmountJoinInstructionsDisplay();

  }

  registerEventEndedEventHandler() {

    const event = this.event;

    if (this.liveStreamEvent === false) {
      return;
    }

    const postId = event.postId;

    application.eventSystem.internal.eventFor(this, `${postId}:${externalEventCodes.STARTUP_EVENT_ENDED}`, this.handleStartupEventEndedEvent.bind(this));

  }

  displayJoinInstructions() {

    this.mountJoinInstructionsDisplay();

    this.registerEventEndedEventHandler();

  }

  updateDisplayByEventStatus() {

    if (this.canShowRecording() === true) {
      this.mountRecordingDisplay();
    } else {
      this.displayJoinInstructions();
    }

  }

  initialize() {

    this.updateDisplayByEventStatus();

  }

}

export default EventBodyContainer;